// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2nfQw","title":"BackImages_title__3Z7wu","images":"BackImages_images__2WeHt"};